
import axios from 'axios';
import React, { Component } from 'react';

import OrderUploadDocumentGroup from './UploadDocumentGroup';


export default class OrderUploadDocuments extends Component {

  constructor(props) {
    super(props);

    this.state = {
      groups: []
    }
  }

  componentDidMount() {
    axios.get('catalog/catalog-document').then(res => {
      this.setState({
        groups: res.data.results
      })
    })
  }

  render() {
    const { order } = this.props;
    const { groups } = this.state;

    return (
      <React.Fragment>
        {groups.map(group =>
          <div className={'mt-15'} key={group.id}>
            <OrderUploadDocumentGroup
              group={group}
              order={order}
              isOpen={group.code === 'TRANSPORT_DOCUMENTS'}
            />
          </div>
        )}
      </React.Fragment>
    )
  }
}
